export const WHITE_BACKGROUND_ROUTES = [
  '/product',
  '/review-your-cart',
  '/portal',
] as const;

export const TRANSPARENT_BACKGROUND_ROUTES = [
  '/portal',
  '/portal/account',
] as const;

export const WHITE_ICONS_ROUTES = ['/blog'] as const;

export function getNavAppearance(
  pathname: string,
  options?: {
    isMenuOpen?: boolean;
    isScrolled?: boolean;
    isTransparent?: boolean;
    selectedSegment?: string | null;
  }
): {
  isBackgroundWhite: boolean;
  requiresTransparentBackground: boolean;
  shouldUseWhiteIcons: boolean;
} {
  const isActivateRoute = options?.selectedSegment === 'activate';
  const isBlogRoute = pathname === '/blog' || pathname.startsWith('/blog/');

  // For blog routes, allow transparent background to be overridden when scrolled
  const baseRequiresTransparentBackground =
    options?.isTransparent ??
    TRANSPARENT_BACKGROUND_ROUTES.includes(
      pathname as (typeof TRANSPARENT_BACKGROUND_ROUTES)[number]
    );

  // On blog routes, if scrolled, override transparent requirement
  const requiresTransparentBackground =
    isBlogRoute && options?.isScrolled
      ? false
      : baseRequiresTransparentBackground;

  const whiteBehaviorRoutes = ['/product', '/review-your-cart'] as const;
  const requiresWhiteBehavior = whiteBehaviorRoutes.includes(
    pathname as (typeof whiteBehaviorRoutes)[number]
  );

  // For blog routes, make background white when scrolled
  const isBackgroundWhite =
    isBlogRoute && options?.isScrolled
      ? true
      : (!WHITE_BACKGROUND_ROUTES.includes(
          pathname as (typeof WHITE_BACKGROUND_ROUTES)[number]
        ) ||
          ((options?.isMenuOpen ?? false) && requiresWhiteBehavior) ||
          ((options?.isScrolled ?? false) && requiresWhiteBehavior)) &&
        !requiresTransparentBackground;

  // For blog routes, use white icons when not scrolled, gradient/black when scrolled
  const shouldUseWhiteIcons = isBlogRoute
    ? !options?.isScrolled
    : isActivateRoute
      ? false
      : !isBackgroundWhite && !requiresTransparentBackground;

  return {
    isBackgroundWhite,
    requiresTransparentBackground,
    shouldUseWhiteIcons,
  };
}
